import { logCoreUsage } from 'owa-analytics';
import { isFeatureEnabled } from 'owa-feature-flags';
import type { BizChatSidePaneSources } from 'owa-bizchat-types';
import type { MailboxInfo } from 'owa-client-types';

/**
 * @param source The entry point source that triggered the BizChat Side Pane opening.
 * @param isFlexPaneAlreadyOpen Indicates whether the BizChat Side Pane is already open,
 *                              used to understand full usage for features that can populate the input box.
 */
export function logBizChatSidePaneEntrypoint(
    source: BizChatSidePaneSources,
    mailboxInfo: MailboxInfo,
    isFlexPaneAlreadyOpen?: boolean,
    isNewChat?: boolean
): void {
    if (isFeatureEnabled('mon-copilot-bizchat')) {
        logCoreUsage('OutlookCopilotChat_BizChatSidePaneEntrypoints', mailboxInfo, {
            source,
            isFlexPaneAlreadyOpen: isFlexPaneAlreadyOpen ?? false,
            isNewChat: isNewChat ?? false,
        });
    }
}
